export const objectToFormData = (objectToConvert = {}) => {
  const objectEntries = Object.entries(objectToConvert);
  const formDataResult = new FormData();

  for (const [key, valye] of objectEntries) {
    formDataResult.append(key, valye);
  }

  return formDataResult;
};
